import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function metricsReducer(state = initialState.metrics, action) {
    switch (action.type) {
        case types.LOAD_METRICS_SUCCESS:
            return action.metrics;
        case types.RESET_METRICS_TABLE:
            return { ...state, pages: -1, onPage: 5, page: 1, data: []};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/analytics/metricsReducer.js